import React, { useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import axios from 'axios';
import './ArticleEditeur.css';

function ArticleEditeur() {
  const [title, setTitle] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const [content, setContent] = useState('## Écrivez votre article ici...');

 // ArticleEditeur.jsx
const handleImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('image', file); // Ajout du fichier à FormData

  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Important pour l'upload d'image
      },
    });

    // Mise à jour de l'état avec l'URL de l'image
    setMainImage(response.data.imageUrl);
  } catch (err) {
    console.error('Erreur lors du téléchargement de l’image :', err.response?.data || err.message);
    alert("Échec de l’envoi de l’image");
  }
};

  

  const handlePublish = async () => {
    try {
      const articleData = {
        title,
        content,
        date: new Date(),
        mainImage,
      };
  
      await axios.post(`${process.env.REACT_APP_API_URL}/api/articles/create`, articleData);
      alert('Article publié avec succès !');
      setTitle('');
      setContent('## Écrivez votre article ici...');
      setMainImage(null);
    } catch (err) {
      console.error('Erreur de publication :', err.response?.data || err.message);
      alert('Erreur lors de la publication');
    }
  };

  return (
    <div className="admin-editor-container">
      <h2>Créer un article</h2>

      <input
        type="text"
        placeholder="Titre de l'article"
        className="admin-title-input"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        className="admin-image-upload"
      />

      {mainImage && <img src={mainImage} alt="Preview" className="admin-preview-image" />}

      <div className="admin-markdown-editor" data-color-mode="light">
  <MDEditor value={content} onChange={setContent} height={400} />
</div>

      <button className="admin-publish-button" onClick={handlePublish}>
        Publier
      </button>
    </div>
  );
}

export default ArticleEditeur;
